const departments = {
    leader: 'Kierownik',
    leaders: 'Kierownicy działu',
    led_departments: 'Zarządzane działy',
    edit_leaders: 'Zarządzaj kierownikami',
    add_leader: 'Dodaj',
    remove_leader: 'Usuń',
    no_leaders: 'Brak kierowników',
    local: 'Zarządzane lokalnie',
    managed_members: 'Członkowie w zakresie zarządzania',
    leader_scope_hint: 'Zarządzaj przypisaniami w swoich działach i poddziałach.',
    leader_permission_hint: 'Kierownicy zarządzają przypisaniami w swoich działach i poddziałach, bez zmiany ról i hierarchii.',
    primary_synced: 'Dział główny jest zarządzany przez Feishu.',
    status_active: 'Aktywny',
    status_suspended: 'Zawieszony',
    status_departed: 'Odszedł',
    status_pending: 'Oczekuje na aktywację',
    search: 'Szukaj',
    previous_page: 'Poprzednia strona',
    next_page: 'Następna strona',
    directory_title: 'Członkowie organizacji',
    member_name: 'Członek',
    search_members: 'Szukaj według nazwy lub loginu',
    include_descendants: 'Uwzględnij poddziały',
    no_members: 'Brak pasujących członków.',
    all_members: 'Wszyscy członkowie',
    all_departments: 'Wszystkie działy',
    edit_member: 'Edytuj działy',
    add_child: 'Dodaj poddział',
    expand_department: 'Rozwiń {{name}}',
    collapse_department: 'Zwiń {{name}}',
    title: 'Działy',
    description: 'Zarządzaj działami i przypisaniami członków tej organizacji.',
    create: 'Utwórz dział',
    edit: 'Edytuj dział',
    name: 'Nazwa działu',
    parent: 'Dział nadrzędny',
    root: 'Brak działu nadrzędnego',
    id: 'ID działu',
    members: 'Działy członków',
    member_id: 'ID użytkownika członka',
    primary: 'Dział główny',
    none: 'Nie ustawiono',
    assignments: 'Przypisania do działów',
    no_assignments: 'Brak przypisań do działów.',
    assignment_hint: 'Przypisz działy lokalne i opcjonalnie dział główny. Przypisania z katalogu są tylko do odczytu.',
    empty: 'Brak działów.',
    readonly: 'Możesz przeglądać działy i swoje przypisania. Aby je zmienić, skontaktuj się z administratorem.',
    load_error: 'Nie udało się wczytać danych. Spróbuj ponownie.',
    mutation_error: 'Nie udało się zapisać. Sprawdź uprawnienia, członkostwo i hierarchię działów.',
    loading: 'Wczytywanie…',
    synced: 'Zarządzane przez katalog',
    choose: 'Szukaj działów',
    organizations_title: 'Organizacje i działy',
    organizations_description: 'Wybierz organizację, aby przeglądać jej działy lub nimi zarządzać.',
    no_organizations: 'Nie należysz do żadnej organizacji. Skontaktuj się z administratorem.',
    organization: 'Bieżąca organizacja',
    choose_organization: 'Wybierz organizację',
    delete_title: 'Usuń dział',
    delete_description: 'Usunąć „{{name}}”? Najpierw przenieś członków i poddziały.',
};
export default Object.freeze(departments);
